import "../../assets/stylesheet/footer.css";

import { useEffect, useState } from "react";

import DrawIcon from "@mui/icons-material/Draw";
import FooterTimer from "./FooterTimer";
import { STEP_MASTER_ENUM, CONFIG_MASTER_ENUM } from "../../constants/constant";
import { currentDate } from "../../helpers/commonHelper";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { getSelectedLanguage } from "../../store/Checkin/languageSlice";
import i18n from "i18next";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getConfigurationCode,
  getStepMaster,
} from "../../helpers/commonHelper";
import { enablePageTimerEnhancements } from "../../constants/timers";
const Footer = ({
  page,
  openModal,
  timerValue,
  showModal,
  restartTimer,
  stopTimer,
  timerCounter,
  timeLimit,
  freezeTimer = false,
}) => {
  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const [pages, setPages] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  // const pages = [
  //   "documentscanning",
  //   "facerecognition",
  //    "upgrade",
  //   "signature",
  //   "payment",
  //   "key",
  //   "thankyou",
  // ];

  const stepReservationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.HOME_PAGE
  );
  const paymentPage = getStepMaster(stepMaster, STEP_MASTER_ENUM.PAYMENT_PAGE);
  const KeyCardPage = getStepMaster(stepMaster, STEP_MASTER_ENUM.KEY_PAGE);
  const faceVerificationPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.FACEVERIFICATION_PAGE
  );

  const configs = stepReservationPage?.configs;
  const disableFooter = getConfigurationCode(
    configs,
    CONFIG_MASTER_ENUM.DISABLE_FOOTER
  );
  useEffect(() => {
    if (disableFooter) {
      setIsVisible(false);
    }
  }, [disableFooter]);
  useEffect(() => {
    if (pages.length === 0 && stepMaster?.length > 0) {
      const newPages = [];
      stepMaster.forEach((item) => {
        if (item.stepCode === STEP_MASTER_ENUM.SCAN_DOCUMENT_PAGE) {
          newPages.push("documentscanning");
        }
        if (item.stepCode === STEP_MASTER_ENUM.FACEVERIFICATION_PAGE) {
          newPages.push("facerecognition");
        }
        if (item.stepCode === STEP_MASTER_ENUM.UPSELL_PAGE) {
          newPages.push("upgrade");
        }
        if (item.stepCode === STEP_MASTER_ENUM.REGISTRATION_CARD_PAGE) {
          newPages.push("signature");
        }
        if (item.stepCode === STEP_MASTER_ENUM.PAYMENT_PAGE) {
          newPages.push("payment");
        }
        if (item.stepCode === STEP_MASTER_ENUM.KEY_PAGE) {
          newPages.push("key");
        }
        if (item.stepCode === STEP_MASTER_ENUM.CHECKIN_THANKYOU_PAGE) {
          newPages.push("thankyou");
        }
        setPages(newPages);
        //setPages(prevPages => [...prevPages, newPages]);
        return null; // Return null to avoid warnings about not returning a value in a map callback
      });
    }
  }, [stepMaster, pages]);

  const activeIcons = {
    documentscanning: "activeDocumentIcon",
    facerecognition: "activeFaceIcon",
    upgrade: "activeUpgradeIcon",
    signature: "activeSignatureIcon",
    payment: "activePaymentIcon",
    key: "activeKeyIcon",
    thankyou: "activeAllDoneIcon",
  };

  // let activeIcon = "";
  // let activeState = {};
  // let pageIndex = pages?.indexOf(page);
  // if (pageIndex !== -1) {
  //   for (let i = 0; i <= pageIndex; i++) {

  //     let currentPage = pages[i];
  //     activeIcon =
  //       activeIcons[currentPage] === "activeAllDoneIcon"
  //         ? "active"
  //         : activeIcons[currentPage];

  //     if (activeIcons[currentPage] !== activeIcons[pages[pageIndex]]) {
  //       activeState[currentPage + "Activated"] = "activated";
  //     }
  //     if (activeIcons[currentPage] === "activeAllDoneIcon") {
  //       activeState[currentPage + "Activated"] = "activated";
  //     }
  //   }
  // }
  const currentActualPage = window.location.hash.replace("#/", ""); // Remove the #/ from the hash

  let activeIcon = "";
  let activeState = {};
  let pageIndex = pages?.indexOf(page);

  // If the page is found in the pages array
  if (pageIndex !== -1) {
    // Loop through pages up to the current page index
    for (let i = 0; i <= pageIndex; i++) {
      let currentPage = pages[i];

      if (
        currentActualPage === "confirmation-number" &&
        page === "documentscanning"
      ) {
        continue;
      }
      if (
        currentActualPage === "passport-scanning-reservation-form/search" &&
        page === "documentscanning"
      ) {
        continue;
      }

      // Set the active icon based on the current page
      activeIcon =
        activeIcons[currentPage] === "activeAllDoneIcon"
          ? "active"
          : activeIcons[currentPage];

      // Mark the page as "activated" once it's reached
      if (activeIcons[currentPage] !== activeIcons[pages[pageIndex]]) {
        activeState[currentPage + "Activated"] = "activated";
      }

      // Make sure all "done" steps, like "activeAllDoneIcon", are marked as activated
      if (activeIcons[currentPage] === "activeAllDoneIcon") {
        activeState[currentPage + "Activated"] = "activated";
      }
    }
  }

  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
  }, []);

  return (
    <footer
      className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 "
      style={{ background: !isVisible ? "transparent" : "" }}
    >
      <div
        className="footer-logo flex-shrink-0 mb-2 mb-md-0"
        style={{ visibility: isVisible ? "visible" : "hidden" }}
      >
        <img id="footer-logo" alt="Logo" className="img-fluid " />
      </div>

      <div
        className="tracker-status d-flex  mt-2 mt-md-0"
        style={{ visibility: isVisible ? "visible" : "hidden" }}
      >
        <div
          className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
            page === "confirmation" ? "active" : "activated"
          }`}
        >
          <span className="bx bx-user-check mat-icon material-symbols-rounded"></span>
          <span className="title mt-2">{t("Check-in Options")}</span>
        </div>

        <span
          className="mat-line d-block mx-auto"
          style={{ width: "2rem", height: "2px" }}
        ></span>
        <div
          className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
            activeIcon === "activeDocumentIcon"
              ? "active"
              : activeState?.documentscanningActivated
          }`}
        >
          <span className="bx bx-scan mat-icon material-symbols-rounded"></span>
          <span className="title mt-2">{t("Document scanning")}</span>
        </div>
        <span
          className="mat-line d-block mx-auto"
          style={{ width: "2rem", height: "2px" }}
        ></span>
        {faceVerificationPage !== null &&
          faceVerificationPage !== undefined && (
            <>
              <div
                className={`mat-icon-wrap  d-flex flex-column align-items-center justify-content-center text-center ${
                  activeIcon === "activeFaceIcon"
                    ? "active"
                    : activeState?.facerecognitionActivated
                }`}
              >
                <span className="mat-icon  material-symbols-outlined">
                  {t("familiar_face_and_zone")}
                </span>
                <span className="title mt-2">{t("Face recognition")}</span>
              </div>
              <span
                className="mat-line d-block mx-auto"
                style={{ width: "2rem", height: "2px" }}
              ></span>
            </>
          )}

        {pages !== null && pages?.includes("upgrade") && (
          <>
            <div
              className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
                activeIcon === "activeUpgradeIcon"
                  ? "active"
                  : activeState?.upgradeActivated
              }`}
            >
              <span className="bx bx-chevrons-up mat-icon material-symbols-rounded"></span>
              {/* <span className="title">Upgrade</span> */}
              <span className="title mt-2">{t("Upgrade")}</span>
            </div>
            <span
              className="mat-line d-block mx-auto"
              style={{ width: "2rem", height: "2px" }}
            ></span>
          </>
        )}

        <div
          className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
            activeIcon === "activeSignatureIcon"
              ? "active"
              : activeState?.signatureActivated
          }`}
        >
          <span className=" mat-icon material-symbols-rounded">
            <DrawIcon fontSize="small" />
          </span>
          <span className="title mt-2">{t("Signature")}</span>
        </div>
        <span
          className="mat-line d-block mx-auto"
          style={{ width: "2rem", height: "2px" }}
        ></span>
        {paymentPage !== null && paymentPage !== undefined && (
          <>
            <div
              className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
                activeIcon === "activePaymentIcon"
                  ? "active"
                  : activeState?.paymentActivated
              }`}
            >
              <span className="bx bxs-credit-card mat-icon material-symbols-rounded"></span>
              <span className="title mt-2">{t("Payment")}</span>
            </div>
            <span
              className="mat-line d-block mx-auto"
              style={{ width: "2rem", height: "2px" }}
            ></span>
          </>
        )}
        {KeyCardPage !== null && KeyCardPage !== undefined && (
          <>
            <div
              className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
                activeIcon === "activeKeyIcon"
                  ? "active"
                  : activeState?.keyActivated
              }`}
            >
              <span className="bx bxs-key mat-icon material-symbols-rounded"></span>
              <span className="title mt-2">{t("Key")}</span>
            </div>
            <span
              className="mat-line d-block mx-auto"
              style={{ width: "2rem", height: "2px" }}
            ></span>
          </>
        )}

        <div
          className={`mat-icon-wrap d-flex flex-column align-items-center justify-content-center text-center ${
            activeIcon === "activeAllDoneIcon"
              ? "active"
              : activeState?.thankyouActivated
          }`}
        >
          <span className="mat-icon material-symbols-rounded">thumb_up</span>
          <span className="title mt-2">{t("Check-in Completed")}</span>
        </div>
      </div>

      {/* 80 */}
      <FooterTimer
        openModal={openModal}
        timerValue={timerValue}
        timerCounter={timerCounter}
        restartTimer={restartTimer}
        showModal={showModal}
        stopTimer={stopTimer}
        timeLimit={timeLimit}
        disableFooter={disableFooter}
        freezeTimer={freezeTimer && enablePageTimerEnhancements}
      />
    </footer>
  );
};

export default Footer;
